'use client';
import { IMovie } from '@/interfaces/movie';
import Image from 'next/image';
import React, { use, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { PiFilmSlateBold } from 'react-icons/pi';

interface IProps {
  movie: IMovie;
}

function BannerMovie({ movie }: IProps) {
  const [name, setName] = useState<string>('');
  const [firstEpisode, setFirstEpisode] = useState<string>('1');
  useEffect(() => {
    setFirstEpisode(movie.episodes[0].items[0].name);
    if (movie.episodes[0].server_name === 'Vietsub #1') {
      setName('vietsub');
    } else if (movie.episodes[0].server_name === 'Lồng Tiếng #1') {
      setName('thuyetminh');
    }
  }, []);

  return (
    <div className="w-full h-96 relative max-md:h-auto max-md:pb-3 flex max-md:block gap-x-5 pt-5 px-6 mt-4">
      <Image
        src={movie.poster_url ?? 'Ảnh mặc định'}
        unoptimized
        quality={100}
        height={192}
        width={240}
        className="object-cover h-full absolute w-full top-0 right-0 opacity-50"
        alt={movie.name ?? 'Ảnh mặc định'}
      />
      <Image
        src={movie.thumb_url ?? 'Ảnh mặc định'}
        unoptimized
        quality={100}
        height={192}
        width={240}
        className="object-cover h-[350px] max-md:h-64 max-md:w-auto max-md:m-auto relative z-10"
        alt={movie.name ?? 'Ảnh mặc định'}
      />
      <div className="relative z-10">
        <h1 className="text-yellowMain font-medium text-[22px] max-lg:text-[16px]">
          {movie.name}
        </h1>
        <div className="text-white font-medium max-lg:text-[14px]">
          {movie.original_name}
        </div>
        <div
          className="text-gray-400 text-[14px] line-clamp-[10] max-md:line-clamp-6 max-md:text-[12px]"
          dangerouslySetInnerHTML={{
            __html: movie.description ?? '',
          }}
        >
          {/* {movie.description} */}
        </div>
        <a
          href={`/phim/${movie.slug}?tap=${firstEpisode}&maychu=${name}`}
          className="bg-redMain flex gap-x-1 max-lg:text-[12px] text-[13px] max-md:static max-md:m-auto w-fit items-center hover:bg-red-600 text-white font-medium py-2 px-4 rounded absolute left-0 bottom-3 cursor-pointer"
        >
          <PiFilmSlateBold color="white" />
          Xem Phim
        </a>
      </div>
    </div>
  );
}

export default BannerMovie;
